/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  createExtendableMediaRecorder,
  registerWavEncoder,
} from '@/lib/extendableMediaRecorder';
import { stopMediaRecorder } from '@/lib/utils';
import { logger } from '@/utils/logger/logger';
import { type IMediaRecorder } from 'extendable-media-recorder';
import { isSafari } from 'react-device-detect';
type OnDataAvailableHandler = (data: Blob) => void;
type OnStopHandler = (blob: Blob) => void;

class Recorder {
  private static instance: Recorder;
  private mediaRecorder: IMediaRecorder | null;
  private chunks: Blob[];
  private stream: MediaStream | null;
  //   private audioContext: AudioContext;
  //   private mediaStreamDestination: MediaStreamAudioDestinationNode;
  public ondataavailable: OnDataAvailableHandler | null;
  public onstop: OnStopHandler | null;

  private constructor() {
    this.mediaRecorder = null;
    this.chunks = [];
    this.stream = null;
    // this.audioContext = new (window.AudioContext ||
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    //   (window as any).webkitAudioContext)();
    // this.mediaStreamDestination = this.audioContext.createMediaStreamDestination();
    this.ondataavailable = null;
    this.onstop = null;
    void registerWavEncoder();

    // void this.init();
  }

  public static getInstance(): Recorder {
    if (!Recorder.instance) {
      Recorder.instance = new Recorder();
    }
    return Recorder.instance;
  }

  private async init() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      void this.handleStream(stream);
    } catch (error) {
      logger.error('Error accessing audio devices:', error);
    }
  }

  private async handleStream(stream: MediaStream) {
    this.stream = stream;

    if (this.mediaRecorder) {
      stopMediaRecorder(this.mediaRecorder);
      this.mediaRecorder = null;
    }

    // const source = this.audioContext.createMediaStreamSource(stream);
    // source.connect(this.mediaStreamDestination);

    const mimeType = this.getSupportedMimeType();

    this.mediaRecorder = await createExtendableMediaRecorder(stream, {
      mimeType,
    });

    // this.mediaRecorder.addEventListener() = (e: BlobEvent) => {
    //   debugger;
    //   if (this.ondataavailable) {
    //     this.ondataavailable(e.data);
    //   }
    //   this.chunks.push(e.data);
    // };

    // Handling mediaRecorder events
    this.mediaRecorder?.addEventListener('dataavailable', (e) => {
      //   logger.debug('audioRecorder data available', e.data.size);

      //   debugger
      if (this.ondataavailable) {
        this.ondataavailable(e.data);
      }
      //   this.chunks.push(e.data);
    });

    this.mediaRecorder.addEventListener('stop', () => {
      const blob = new Blob(this.chunks, { type: mimeType });
      this.chunks = [];
      if (this.onstop) {
        this.onstop(blob);
      }
      // Handle the blob further if needed (e.g., save, play, upload)
    });
  }

  private getSupportedMimeType(): string {
    return 'audio/wav';
    // const mimeTypes = ['audio/wav', 'audio/wave', 'audio/x-wav'];
    // for (const mimeType of mimeTypes) {
    //   if (MediaRecorder.isTypeSupported(mimeType)) {
    //     return mimeType;
    //   }
    // }
    // return ''; // Fallback to default type if none of the desired types are supported
  }

  public async start() {
    if (!this.stream) {
      await this.init();
    }

    // debugger;
    if (this.mediaRecorder && this.mediaRecorder.state === 'inactive') {
      this.mediaRecorder.start(1000);
    }
  }

  public stop() {
    if (this.mediaRecorder && this.mediaRecorder.state === 'recording') {
      this.mediaRecorder.stop();
    }

    if (this.stream) {
      this.stream.getTracks().forEach((track) => track.stop());
    }
  }

  public async changeInputDevice(deviceId: string) {
    if (this.stream) {
      this.stream.getTracks().forEach((track) => track.stop());
    }

    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: false,
        audio: isSafari
          ? {
              deviceId: deviceId,
            }
          : {
              autoGainControl: false,
              echoCancellation: false,
              noiseSuppression: false,

              deviceId: deviceId,
            },
      });
      await this.handleStream(stream);
    } catch (error) {
      logger.error('Error changing audio input device:', error);
    }
  }

  public setOnDataAvailableHandler(handler: OnDataAvailableHandler) {
    this.ondataavailable = handler;
  }

  public setOnStopHandler(handler: OnStopHandler) {
    this.onstop = handler;
  }
}

const isBrowser = () => typeof window !== 'undefined'; //The approach recommended by Next.js

export default isBrowser() ? Recorder.getInstance() : null;
